import { createContext } from 'react';

import { I18nStore } from '../i18n';

export default createContext<I18nStore>(null as any);
